import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from '../services/date-format.service';

@Pipe({
	name: 'localizedDate',
	pure: false
})
export class LocalizedDatePipe implements PipeTransform {
	constructor(private readonly dateFormatService: DateFormatService) {}

	transform(
		value: any,
		pattern = 'mediumDate',
		timeZone: string | null = null
	): any {
		return this.dateFormatService.formatLocalized(value, pattern, timeZone);
	}
}
